
import axios from 'axios';

const service = axios.create({
  timeout: 50000, 
});

service.interceptors.request.use(
  config =>
    config,
  (error) => {
    // Do something with request error
    console.log(error); 
    return Promise.reject(error);
  },
);


service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code === 200) {
      return response.data;
    } if (res.code === 500) {
      window.location.href = '/';

    } else {
      return Promise.reject('error');
    }
  },
  (error) => {
    console.log(`err${error}`); // for debug
    return Promise.reject(error);
  },
);


export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, { params }).then((res) => {
      resolve(res.data);
    }).catch((err) => {
      reject(err);
    });
  });
}

export function getss(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url,
      xhrFields: {
        withCredentials: true,
      }, 
      crossDomain: true,
      params,
    }).then((res) => {
      resolve(res.data);
    }).catch((err) => {
      reject(err);
    });
  });
}
// xhrFields: {withCredentials:true}, 

export function gets(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url,
      responseType: 'blob',
    }).then((res) => {
      resolve(res);
    }).catch((err) => {
      reject(err);
    });
  });
}

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data, {
      // headers: {
      //     Accept: "application/x-www-form-urlencoded; charset=utf-8",
      //     "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8;",
      // }
    }).then((response) => {
      resolve(response.data);
    }, (err) => {
      reject(err);
    });
  });
}

export function posts(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8;',
      },
    }).then((response) => {
      resolve(response.data);
    }, (err) => {
      reject(err);
    });
  });
}
